import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

const checkFormValidation = (Component) => {
  return ({ validationProps, ...props }) => {
    const { form, fields, onInvalid, redirectUrl, baseRedirectUrl } = validationProps;

    useEffect(() => {
      if (!form.isValid && !props.match.url.includes(redirectUrl) && !form.isSubmitting) {
        if (fields) {
          const touchedFields = Object.keys(fields).reduce((obj, key) => {
            obj[key] = true;

            return obj;
          }, {});

          form.setTouched(touchedFields);
        }

        onInvalid && onInvalid();
      }
    }, [form.isValid, form.isSubmitting, props.match.url]);

    if (form.isValid) {
      return <Component {...props} />;
    }

    const url = props.match.url.includes(redirectUrl) || !redirectUrl ? baseRedirectUrl : redirectUrl;

    return <Redirect to={url} />;
  };
};

export default checkFormValidation;
